export interface Login {
  otlid: string;
  login: boolean;
}

export interface EmailPassword {
  email: string;
  password: string;
}
